import axios from "axios";
import localService from "../services/localService";
import { store } from "../main";
import { useAuthStore } from "../stores/auth";

const GET_API_URL = () => {
  return process.env.VUE_APP_API_URL;
};

const startLoading = () => {
  const authStore = useAuthStore();
  authStore.startLoading();
};

const stopLoading = () => {
  const authStore = useAuthStore();
  authStore.stopLoading();
};

const options = {
  baseURL: GET_API_URL(),
  headers: {
    "Content-Type": "application/json",
  },
};

const instance = axios.create({ ...options });

instance.interceptors.request.use((config) => {
  startLoading();
  const token = localService.getItem("breton-token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

instance.interceptors.response.use(
  (response) => {
    stopLoading();
    return response;
  },
  (error) => {
    stopLoading();

    if (error?.response?.status === 401) {
      const authStore = useAuthStore();
      authStore.logout();
    }

    return Promise.reject(error);
  },
);

export default instance;
